import moment from 'moment'
import React from 'react'
import format, { DEFAULT_TIME_ZONE } from 'civic-champs-shared/utils/format'
import { OrgNamedRef } from 'civic-champs-shared/question-sets/types'
import { ExportButton } from 'core/table/components'
import map from 'lodash/map'

const formatPhones = (phones: string[], obj: any) =>
  phones.reduce((acc: any, phone: string) => ({ ...acc, [phone]: format.phoneNumber(obj?.[phone]) }), {})

const headers = [
  { label: 'Volunteer First Name', key: 'firstName' },
  { label: 'Volunteer Last Name', key: 'lastName' },
  { label: 'Volunteer Email Address', key: 'email' },
  { label: 'Volunteer Mobile Phone', key: 'phoneNumber' },
  { label: 'Volunteer Home Phone', key: 'homePhoneNumber' },
  { label: 'Volunteer Groups', key: 'groups' },
  { label: 'Volunteer Tags', key: 'volunteerTags' },
  { label: 'Volunteer Address', key: 'address' },
  { label: 'Emergency Contact First Name', key: 'emergencyContact.givenName' },
  { label: 'Emergency Contact Last Name', key: 'emergencyContact.familyName' },
  { label: 'Emergency Contact Relationship', key: 'emergencyContactRelationship' },
  { label: 'Emergency Contact Mobile Phone', key: 'emergencyContact.phoneNumber' },
  { label: 'Emergency Contact Work Phone', key: 'emergencyContact.workPhoneNumber' },
  { label: 'Emergency Contact Home Phone', key: 'emergencyContact.homePhoneNumber' },
  { label: 'Emergency Contact Email Address', key: 'emergencyContact.email' },
  { label: 'Event Name', key: 'eventName' },
  { label: 'Event Date', key: 'eventDate' },
  { label: 'Signup Date', key: 'signupDate' },
  { label: 'Volunteer Shift', key: 'shiftName' },
  { label: 'Shift Time', key: 'shiftTime' },
  { label: 'Volunteer Role', key: 'roleName' },
  { label: 'Volunteer Status', key: 'status' },
  { label: 'Waivers Status', key: 'waiverStatus' },
]
const formatData = (registrants: any[]) =>
  registrants.map(
    ({
      original: {
        user,
        opportunity,
        occurrence,
        unsignedWaivers,
        role,
        timeshift,
        status,
        groups,
        volunteerTags,
        createdAt,
      },
    }) => ({
      firstName: user.givenName,
      lastName: user.familyName,
      eventName: occurrence.name,
      eventDate: format.datetime(occurrence.startsAt),
      shiftName: timeshift.name,
      shiftTime: `${timeshift.timeStart} - ${timeshift.timeEnd}`,
      roleName: role.name,
      waiverStatus: unsignedWaivers.length ? 'Action Required: ' + map(unsignedWaivers, 'title').join(',') : 'Complete',
      email: user.email,
      phoneNumber: format.phoneNumber(user.phoneNumber),
      homePhoneNumber: format.phoneNumber(user.homePhoneNumber),
      status,
      signupDate: format.datetime(createdAt),
      groups: groups.map(({ name }: any) => name).join(', '),
      volunteerTags: (volunteerTags || []).map(({ name }: any) => name).join(', '),
      address: format.address(user.address),
      emergencyContactRelationship: user.emergencyContactRelationship,
      emergencyContact: {
        ...user.emergencyContact,
        ...formatPhones(['phoneNumber', 'homePhoneNumber', 'workPhoneNumber'], user.emergencyContact),
      },
    }),
  )

const formatFileName = (filename: string, organization: OrgNamedRef, separator: string = '_') => {
  const today = moment()
    .tz(organization.timeZone || DEFAULT_TIME_ZONE)
    .format(`DDMMMYYYY${separator}HH:mm`)
  return `${organization.name}${separator}${filename}${separator}${today}.csv`
}

export const ExportRegistrantsButton = ({
  data,
  disabled,
  organization,
}: {
  data: any[]
  disabled?: boolean
  organization: OrgNamedRef
}) => (
  <ExportButton
    data={data}
    disabled={disabled}
    formatData={formatData}
    headers={headers}
    filename={formatFileName('registrations', organization)}
  />
)

export default ExportRegistrantsButton
